function createKeyEventHandler() {
  const keyEvents = new Map();
  
  const listener = (event) => {
    if (keyEvents.has(event.code)) {
      keyEvents.get(event.code)(event);
    }
  };

  return {
    addKeyEvent: (key, callback) => {
      keyEvents.set(key, callback);
    },
    removeKeyEvent: (key) => {
      keyEvents.delete(key);
    },
    enable: () => {
      document.addEventListener("keydown", listener);
    },
    disable: () => {
      document.removeEventListener("keydown", listener);
    }
  };
}

export default createKeyEventHandler;

// const keyHandler = KeyEventHandler();
// keyHandler.addKeyEvent("KeyA", (event) => {
//   console.log("KeyA pressed");
// });
// keyHandler.enable();